var _polygon, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconWiFi6E(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "45.604 56.75 45.604 55.25 41.245 55.25 41.245 62.272 45.601 62.272 45.601 60.772 42.745 60.772 42.745 59.458 44.691 59.458 44.691 57.958 42.745 57.958 42.745 56.75 45.604 56.75"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.52051,29.46045A43.66483,43.66483,0,0,0,40,17.25,43.66483,43.66483,0,0,0,9.47949,29.46045l1.041,1.0791A42.17576,42.17576,0,0,1,40,18.75,42.17576,42.17576,0,0,1,69.47949,30.53955Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.52148,39.46045a29.75127,29.75127,0,0,0-41.043,0l1.043,1.0791a28.24873,28.24873,0,0,1,38.957,0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.52051,49.46045a15.24885,15.24885,0,0,0-21.041,0l1.041,1.0791a13.75116,13.75116,0,0,1,18.959,0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.37891,56.04785l-.35743-1.457c-2.79785.688-3.83789,2.15088-3.83789,5.39844A2.73926,2.73926,0,1,0,36.92285,57.25a2.70086,2.70086,0,0,0-.73633.11328A3.13274,3.13274,0,0,1,38.37891,56.04785ZM36.92285,58.75a1.23926,1.23926,0,1,1-1.23926,1.23926A1.24063,1.24063,0,0,1,36.92285,58.75Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWiFi6E);
export default __webpack_public_path__ + "static/media/icon_wi-fi_6e.66cfc272ec570b9529f550cc452f9580.svg";
export { ForwardRef as ReactComponent };